/**
 * @generated SignedSource<<4d81be4d334085a6f19a21a6cf611092>>
 * @relayHash 4d74738b8f309d1cb492c3e8bf68556e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8c0db30c0c84de2c44f244ef293fcddab7837c3ac920e1fdac5cb901518754ac

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CcpEntitlementPreDunningStatus = "IN_PRE_DUNNING" | "NOT_IN_PRE_DUNNING" | "%future added value";
export type CommerceEntitlementFilter = {
  AND?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  OR?: ReadonlyArray<CommerceEntitlementFilter | null | undefined> | null | undefined;
  inPreDunning?: boolean | null | undefined;
  inTrialOrPreDunning?: boolean | null | undefined;
};
export type editionAwarenessQuery$variables = {
  chargeElement: string;
  cloudId: string;
  entitlementFilter?: CommerceEntitlementFilter | null | undefined;
  productKey: string;
  shouldCheckBillingAdmin: boolean;
  shouldCheckForChangeOffering: boolean;
  shouldCheckForChargeQuantities: boolean;
  shouldCheckForPaidOffering: boolean;
  shouldCheckForTrial: boolean;
  shouldCheckForTwc: boolean;
  shouldSkip: boolean;
  trialOfferingName: string;
};
export type editionAwarenessQuery$data = {
  readonly tenantContexts?: ReadonlyArray<{
    readonly entitlementInfo: {
      readonly entitlement: {
        readonly __typename: string;
        readonly experienceCapabilities?: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly offering?: {
          readonly trial: {
            readonly lengthDays: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly preDunning?: {
          readonly status: CcpEntitlementPreDunningStatus | null | undefined;
        } | null | undefined;
        readonly relatesFromEntitlements?: ReadonlyArray<{
          readonly entitlementId: string | null | undefined;
          readonly relationshipType: string | null | undefined;
        } | null | undefined> | null | undefined;
        readonly subscription?: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly experienceCapabilities: {
                readonly configurePaymentV2: {
                  readonly experienceUrl: string | null | undefined;
                  readonly isAvailableToUser: boolean | null | undefined;
                } | null | undefined;
              } | null | undefined;
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
          readonly trial: {
            readonly timeLeft: number | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly transactionAccount?: {
          readonly isCurrentUserBillingAdmin: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly paidEntitlement?: {
        readonly __typename: string;
        readonly experienceCapabilities: {
          readonly changeOfferingV2: {
            readonly experienceUrl: string | null | undefined;
            readonly isAvailableToUser: boolean | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly subscription: {
          readonly accountDetails: {
            readonly invoiceGroup: {
              readonly invoiceable: boolean | null | undefined;
            } | null | undefined;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"audienceAndTiming_AtlassianEditionAwareness">;
};
export type editionAwarenessQuery = {
  response: editionAwarenessQuery$data;
  variables: editionAwarenessQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "chargeElement"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitlementFilter"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckBillingAdmin"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChangeOffering"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForChargeQuantities"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForPaidOffering"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTrial"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldCheckForTwc"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkip"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "trialOfferingName"
},
v12 = [
  {
    "items": [
      {
        "kind": "Variable",
        "name": "cloudIds.0",
        "variableName": "cloudId"
      }
    ],
    "kind": "ListValue",
    "name": "cloudIds"
  }
],
v13 = [
  {
    "kind": "Variable",
    "name": "hamsProductKey",
    "variableName": "productKey"
  }
],
v14 = [
  {
    "kind": "Literal",
    "name": "where",
    "value": {
      "inTrialOrPreDunning": false
    }
  }
],
v15 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v16 = [
  {
    "kind": "Variable",
    "name": "offeringName",
    "variableName": "trialOfferingName"
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "isAvailableToUser"
},
v18 = {
  "kind": "ScalarField",
  "name": "experienceUrl"
},
v19 = {
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    {
      "args": (v16/*: any*/),
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": [
        (v17/*: any*/),
        (v18/*: any*/)
      ]
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "invoiceable"
},
v21 = [
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "entitlementFilter"
  }
],
v22 = {
  "kind": "ScalarField",
  "name": "status"
},
v23 = {
  "kind": "ScalarField",
  "name": "timeLeft"
},
v24 = {
  "kind": "ScalarField",
  "name": "lengthDays"
},
v25 = {
  "kind": "ScalarField",
  "name": "isCurrentUserBillingAdmin"
},
v26 = {
  "kind": "ScalarField",
  "name": "relationshipType"
},
v27 = {
  "kind": "ScalarField",
  "name": "entitlementId"
},
v28 = {
  "kind": "ScalarField",
  "name": "id"
},
v29 = {
  "kind": "LinkedField",
  "name": "experienceCapabilities",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    {
      "args": (v16/*: any*/),
      "kind": "LinkedField",
      "name": "changeOfferingV2",
      "plural": false,
      "selections": [
        (v15/*: any*/),
        (v17/*: any*/),
        (v18/*: any*/)
      ]
    }
  ]
},
v30 = [
  (v28/*: any*/)
],
v31 = {
  "kind": "InlineFragment",
  "selections": (v30/*: any*/),
  "type": "CcpInvoiceGroup"
},
v32 = {
  "kind": "InlineFragment",
  "selections": (v30/*: any*/),
  "type": "CcpSubscription"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/)
    ],
    "kind": "Fragment",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "audienceAndTiming_AtlassianEditionAwareness"
      },
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v12/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v13/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  {
                    "condition": "shouldCheckForPaidOffering",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "paidEntitlement",
                        "args": (v14/*: any*/),
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v19/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ],
                        "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
                      }
                    ]
                  },
                  {
                    "args": (v21/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "condition": "shouldCheckForChangeOffering",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v19/*: any*/)
                        ]
                      },
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "preDunning",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v20/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v18/*: any*/),
                                              (v17/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v24/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckBillingAdmin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/)
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForTwc",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              (v26/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v11/*: any*/),
      (v5/*: any*/),
      (v8/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v7/*: any*/),
      (v4/*: any*/),
      (v9/*: any*/)
    ],
    "kind": "Operation",
    "name": "editionAwarenessQuery",
    "selections": [
      {
        "condition": "shouldSkip",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": (v12/*: any*/),
            "concreteType": "TenantContext",
            "kind": "LinkedField",
            "name": "tenantContexts",
            "plural": true,
            "selections": [
              {
                "args": (v13/*: any*/),
                "kind": "LinkedField",
                "name": "entitlementInfo",
                "plural": false,
                "selections": [
                  (v15/*: any*/),
                  {
                    "args": (v21/*: any*/),
                    "kind": "LinkedField",
                    "name": "entitlement",
                    "plural": false,
                    "selections": [
                      (v15/*: any*/),
                      {
                        "condition": "shouldCheckForChargeQuantities",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "chargeElement",
                                "variableName": "chargeElement"
                              }
                            ],
                            "kind": "ScalarField",
                            "name": "latestUsageForChargeElement"
                          }
                        ]
                      },
                      (v28/*: any*/),
                      {
                        "condition": "shouldCheckForChangeOffering",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          (v29/*: any*/)
                        ]
                      },
                      {
                        "condition": "shouldCheckForTrial",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "preDunning",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v22/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v23/*: any*/)
                                ]
                              },
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v20/*: any*/),
                                      {
                                        "kind": "LinkedField",
                                        "name": "experienceCapabilities",
                                        "plural": false,
                                        "selections": [
                                          (v15/*: any*/),
                                          {
                                            "kind": "LinkedField",
                                            "name": "configurePaymentV2",
                                            "plural": false,
                                            "selections": [
                                              (v15/*: any*/),
                                              (v18/*: any*/),
                                              (v17/*: any*/)
                                            ]
                                          }
                                        ]
                                      },
                                      (v31/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v32/*: any*/)
                            ]
                          },
                          {
                            "kind": "LinkedField",
                            "name": "offering",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "trial",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  (v24/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": (v30/*: any*/),
                                "type": "Node",
                                "abstractKey": "__isNode"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckBillingAdmin",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "transactionAccount",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              (v25/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v30/*: any*/),
                                "type": "CcpTransactionAccount"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "condition": "shouldCheckForTwc",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "relatesFromEntitlements",
                            "plural": true,
                            "selections": [
                              (v15/*: any*/),
                              (v26/*: any*/),
                              (v27/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "condition": "shouldCheckForPaidOffering",
                    "kind": "Condition",
                    "passingValue": true,
                    "selections": [
                      {
                        "alias": "paidEntitlement",
                        "args": (v14/*: any*/),
                        "kind": "LinkedField",
                        "name": "entitlement",
                        "plural": false,
                        "selections": [
                          (v15/*: any*/),
                          (v29/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "subscription",
                            "plural": false,
                            "selections": [
                              (v15/*: any*/),
                              {
                                "kind": "LinkedField",
                                "name": "accountDetails",
                                "plural": false,
                                "selections": [
                                  (v15/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "name": "invoiceGroup",
                                    "plural": false,
                                    "selections": [
                                      (v15/*: any*/),
                                      (v20/*: any*/),
                                      (v31/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v32/*: any*/)
                            ]
                          },
                          (v28/*: any*/)
                        ],
                        "storageKey": "entitlement(where:{\"inTrialOrPreDunning\":false})"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8c0db30c0c84de2c44f244ef293fcddab7837c3ac920e1fdac5cb901518754ac",
    "metadata": {},
    "name": "editionAwarenessQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "ac37a1797ba24af79205ff2b6ba49399";

export default node;
